import {
    useCallback,
} from 'react'
import {
    useQueryClient,
} from '@tanstack/react-query'

import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Contact/Contact.requests'
import {
    Contact,
} from '../Contacts.types'

const useGetContact = (id: number) => {
    const queryClient = useQueryClient()

    const invalidate = useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: [RequestKeys.getContact],
        })
    }, [queryClient])

    const {
        data,
        isDataReady,
        isError,
        isFetching,
        error,
    } = useRequest<Contact>({
        key: RequestKeys.getContact,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetContact
